var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rakuAi"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"https://aitest.rakumart.com/intelligentImage","frameborder":"0"}})])
}]

export { render, staticRenderFns }